<div class="row">
  <div class="col-12">
    <div class="row mt-3">
      <div class="col-12 p-0">
        <p class="mb-0">
          <button class="btn btn-primary collapsible" type="button" data-toggle="collapse"
            data-target="#allCaseCriteria" aria-expanded="false" aria-controls="allCaseCriteria">
            ค้นหา
            <i class="fa" aria-hidden="true"></i>
          </button>
        </p>
        <div class="collapse" id="allCaseCriteria">
          <div class="card card-body">
              <div class="row">
                <div class="col-2 text-right">
                  <label>Case Id:</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" [(ngModel)]="caseNoAll">
                </div>

                <div class="col-2 text-right">
                  <label>ชื่อ:</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" [(ngModel)]="firstnameAll">
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-2 text-right">
                  <label>เบอร์โทร:</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control number" [(ngModel)]="telephoneAll">
                </div>

                <div class="col-2 text-right">
                  <label>นามสกุล:</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" [(ngModel)]="lastnameAll">
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-2 text-right">
                  <label>ประเภทรายงานการติดต่อ:</label>
                </div>
                <div class="col-4">
                  <select class="form-control" [(ngModel)]="caseTypeAll" (change)="onCaseTypeAllChange()">
                    <option selected value="">กรุณาเลือก</option>
                    <option *ngFor="let c of caseTypeList" [value]="c.dpa_casetypeid">
                      {{c.dpa_name}}
                    </option>
                  </select>
                </div>

                <div class="col-2 text-right">
                  <label>หัวข้อการติดต่อ:</label>
                </div>
                <div class="col-4">
                  <select class="form-control" [(ngModel)]="caseSubTypeAll" (change)="onCaseSubTypeAllChange()">
                    <option selected value="">กรุณาเลือก</option>
                    <option *ngFor="let c of caseSubTypeAllList" [value]="c.dpa_casesubtypeid">
                      {{c.dpa_name}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-2 text-right">
                  <label>หัวข้อย่อย:</label>
                </div>
                <div class="col-4">
                  <select class="form-control" [(ngModel)]="subTypeDetailAll">
                    <option selected value="">กรุณาเลือก</option>
                    <option *ngFor="let c of caseSubTypeDetailAllList" [value]="c.dpa_casesubtypedetailid">
                      {{c.dpa_name}}
                    </option>
                  </select>
                </div>

                <div class="col-2 text-right">
                  <label>สถานะ:</label>
                </div>
                <div class="col-4">
                  <select class="form-control" [(ngModel)]="statusAll">
                    <option selected value="">กรุณาเลือก</option>
                    <option *ngFor="let c of caseStatusList" [value]="c.dpa_casestatusid">
                      {{c.dpa_name}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-2 text-right">
                  <label>วันที่:</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" data-provide="datepicker" data-date-language="th-th"  id="dateFromAll" />
                </div>

                <div class="col-2 text-right">
                  <label>ถึงวันที่:</label>
                </div>
                <div class="col-4">
                  <input type="text" class="form-control" data-provide="datepicker" data-date-language="th-th"  id="dateToAll" />
                </div>
              </div>

            <div class="row mt-2">
              <div class="col-12 text-center">
                <button class="btn btn-primary m-2" (click)="searchAllCase()">
                  ค้นหา
                  <span class="fa fa-search"></span>
                </button>
                <button class="btn btn-default m-2" (click)="resetSearchAllCase()">
                  ล้างค่า
                  <span class="fa fa-times"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card card-default">
      <div class="card-header">
        <div class="row">
          <div class="col-8 my-auto">
            <h3 class="card-title font-cust-blue">All Case</h3>
          </div>
          <div class="col-4">
            <div class="row">
              <div class="col-4 text-center">
                <span class="dot high"></span>
                <label class="high">{{allHigh}}</label>
                <br>
                <label class="high">High</label>
              </div>
              <div class="col-4 text-center">
                <span class="dot medium"></span>
                <label class="medium">{{allMedium}}</label>
                <br>
                <label class="medium">Medium</label>
              </div>
              <div class="col-4 text-center">
                <span class="dot low"></span>
                <label class="low">{{allLow}}</label>
                <br>
                <label class="low">Low</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.card-header -->
      <div class="card-body table-responsive">
        <table #tbAll id="tbAllCase" style="width:100%" class="table table-bordered table-hover result-table">
          <thead>
            <tr>
              <th>Priority</th>
              <th>Case ID</th>
              <th>Case Sub Type</th>
              <th>Contact</th>
              <th>Origin Source</th>
              <th>Status</th>
              <th>Date</th>
              <th>SLA</th>
              <th>Due Date</th>
            </tr>
          </thead>
          <tbody>
            <!-- <tr *ngFor="let c of allCaseList; let i = index">
              <td align="center" class="text-white">
                <span class="{{'dot ' + c.dpa_caseseverityidname | lowercase}}"></span>
              </td>
              <td class="col-id">{{c.ticketnumber}}</td>
              <td>{{c.dpa_casesubtypeidname}}</td>
              <td>{{c.customeridname}}</td>
              <td>{{c.dpa_casechannelidname}}</td>
              <td>{{c.dpa_casestatusidname}}</td>
              <td>{{c.createdon | thaidate: 'shortWithTime'}}</td>
              <td align="center" class="high">{{c.dpa_issla ? 'Over': ''}}</td>
              <td>{{c.dpa_slatime | thaidate: 'shortWithTime'}}</td>
            </tr> -->
          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>



<!-- Modal Take Case-->
<div class="modal fade" id="takeCaseModal" tabindex="-1" role="dialog" aria-labelledby="takeCaseModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="takeCaseModalLabel">ยืนยันรับเคส</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-info mr-2" (click)="takeCase()">ใช่ ยืนยัน</button>
            <button type="button" class="btn btn-info ml-2" data-dismiss="modal">ยกเลิก</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared-case/shared-case.component.html